
import { defineComponent } from 'vue'
import { iFunction } from '../../FunctionsCatalog'
import FunctionsCatalogInputColumnsCard from './FunctionsCatalogInputColumnsCard.vue'
import FunctionsCatalogInputVariablesCard from './FunctionsCatalogInputVariablesCard.vue'

export default defineComponent({
    name: 'function-catalog-input-tab',
    components: { FunctionsCatalogInputColumnsCard, FunctionsCatalogInputVariablesCard },
    props: { propFunction: { type: Object }, readonly: { type: Boolean } },
    data() {
        return {
            selectedFunction: {} as iFunction
        }
    },
    created() {
        this.loadFunction()
    },
    methods: {
        loadFunction() {
            this.selectedFunction = this.propFunction as iFunction
        }
    }
})
